import React, { RefObject } from "react";
import { Link } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";

import { UserProp } from "app/GraphqlGeneratedTypes/types";

import Avatar from "app/components/concept/Avatar/Avatar";

import shortenString from "app/utils/shortenString";

import classes from "../AppHeader/style.scss";

interface PropsInterface {
	activeUser: UserProp & { avatar: string };
	setClickedHeaderMenu: (value: string | null) => void;
	onLogOutClick: (e: React.MouseEvent<HTMLAnchorElement>) => Promise<void>;
	ignoreRef?: RefObject<HTMLDivElement>;
}
const AccountDropdownMenu: React.FC<PropsInterface> = ({
	activeUser,
	setClickedHeaderMenu,
	onLogOutClick,
	ignoreRef
}) => {
	const onOutsideClickHandler = (e) => {
		if (ignoreRef?.current && ignoreRef.current.contains(e.target)) {
			return;
		}

		setClickedHeaderMenu(null);
	};

	return (
		<OutsideClickHandler onOutsideClick={onOutsideClickHandler}>
			<div className={classes.headerItemDropdown}>
				{activeUser
					? (
						<div className={classes.headerItemDropdownContent}>
							<div className={classes.accountDropDownHeader}>
								<Avatar user={activeUser} onClick={() => {}}/>

								<p className={classes.accountData}>
									<span className={classes.accountName}>
										{`${activeUser.firstName} ${activeUser.lastName}`}
									</span>

									<span className={classes.accountEmail}>
										{shortenString(activeUser.email || "", 27)}
									</span>
								</p>
							</div>
										
							<Link
								className={classes.profileButton}
								to="/settings"
								onClick={() => setClickedHeaderMenu(null)}
							>
								<p className={classes.option}>
									<i className="fa-sharp fa-regular fa-gear fa-sm"/>

									<span>Settings</span>
								</p>
							</Link>

							<Link
								className={classes.profileButton}
								to="/"
								onClick={(e) => {
									setClickedHeaderMenu(null);
									onLogOutClick(e);
								}}
							>
								<p className={classes.option}>
									<i className="fa-sharp fa-regular fa-arrow-right-from-bracket fa-sm"/>

									<span>Log Out</span>
								</p>
							</Link>
						</div>
					)
					: <div className={classes.headerItemDropdownContent}>
						<Link
							className={classes.profileButton}
							to="/login"
							onClick={() => setClickedHeaderMenu(null)}
						>
							<p className={classes.option}>
								<i className="fa-sharp fa-regular fa-arrow-left-to-bracket fa-sm"/>

								<span>Log In</span>
							</p>
						</Link>
					</div>
				}
			</div>
		</OutsideClickHandler>
	);
};

export default AccountDropdownMenu;
